import React from 'react';

export function getOnlineStatusCircle(isOnline=false) {

  const fillColor = isOnline ? "#50E3C2" : "#F18E9A"

  return (
    <svg width="12" viewBox="0 0 31 31" version="1.1">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle id="Oval-2" fill={fillColor} cx="15.5" cy="15.5" r="15.5"></circle>
      </g>
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/battle/ConsoleView/get-online-status-svg.js